import React, { useState, useEffect, useCallback } from 'react';
import { Header } from './components/Header';
import styled from 'styled-components';
import { Footer } from './components/Footer';
import { ContactForm } from './components/ContactForm';
import { RenovationOffice } from './components/RenovationOffice';
import { RenovationHome } from './components/RenovationHome';
import { Home } from './components/Home';
import { AboutUsCard } from './components/AboutUsCard';
import IconsCard from './components/IconsCard';
import { ContactCard } from './components/ContactCard';
import { BackToTopButton } from './components/BackToTopButton';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { Layout } from './components/Layout';
import { WhatsappButton } from './components/WhatsappButton';


export function App() {
  const [formIsDisplayed, setFormIsDisplayed] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const listenToScroll = useCallback(() => {
    let heightToShowFrom = 200;
    const winScroll = document.body.scrollTop ||
      document.documentElement.scrollTop;

    setIsVisible(winScroll > heightToShowFrom);
  }, [setIsVisible]);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () =>
      window.removeEventListener("scroll", listenToScroll);
  }, [listenToScroll])

  return (
    <Router>
      <Routes>
        <Route path="/" element={<>
          <Header />
          <AppLayout>
            {formIsDisplayed && <ContactForm handleClose={() => setFormIsDisplayed(false)} />}
            <Home handleClick={() => setFormIsDisplayed(true)} />
          </AppLayout>
          <AboutUsCard />
          <Layout>
            <IconsCard />
          </Layout>
          <RenovationHome />
          <RenovationOffice />
          <Layout>
            <ContactCard handleClick={() => setFormIsDisplayed(true)} />
            {isVisible && <BackToTopButton />}
            <WhatsappButton />
          </Layout >
          <Footer />
        </>} />
        <Route path="/privacy-policy" element={<>
          <Header />
          <Layout>
            <PrivacyPolicy />
          </Layout >
          <Footer />
        </>} />
      </Routes>
    </Router>
  );
}

const AppLayout = styled(Layout)`
    min-height: 100vh;
    overflow-x: hidden;
`;